import Loader from "./LoaderContainer";
import ShowFullscreenLoader from "./ShowFullscreenLoader";

export {
  ShowFullscreenLoader,
  Loader,
};

export default Loader;
